import { Formik, Form, Field } from 'formik'
import React, { useCallback, useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import { useHistory } from 'react-router-dom'
import Loading from 'custom/assets/loaders/Loading'
import AccountDisplay from '../../../components/account-display/account-display'
import BeneficiaryDisplay from '../../../components/beneficiary-display/beneficiary-display'
import { NeoOTP, NeoSuccess } from '../../../components/FormComponents'
import InputError from '../../../components/InputError/InputError'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoInput from '../../../components/NeoInput/NeoInput'
import { RepeatTransferSchema } from '../../../schemas/beneficiary-transfer'
import BeneficiaryTransferService from '../../../services/beneficiary-transfers.service'
import QuickPayService from '../../../services/quick-pay.service'
import { useDispatch, useSelector } from 'react-redux'
import { setAccRefresh } from '../../../actions'
import LayoutWithOutAccountCard from '../../../layout/Layout/layout-without-card'
import { accountsSelector } from '../../../selectors'
import Pagination from 'react-js-pagination'
import TermsAndConditions from '../../../components/TermsAndConditions/TermsAndCondition'
import { useTranslation } from 'react-i18next'
import {
  BENEFICIARY_TRANSFER_KEYS,
  SIDENAV_KEYS,
  REQUESTS_KEYS,
  DEPOSITS_KEYS,
  VALIDATION_MESSAGES,
} from '../../../utils/translation-constants'
import config from 'custom/config/environment'
import DashboardService from '../../../services/dashboard.service'

export default function RepeatPayment() {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [stage, setStage] = useState(0)
  const [statementList, setStatementList] = useState([])
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [otp, setOtp] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [selectedDetails, setSelectedDetails] = useState({})
  const [formValues, setFormValues] = useState({
    transferAmount: '',
    amount: '',
    remarks: '',
    customRemarks: '',
  })
  const [verifyDetails, setVerifyDetails] = useState({})
  const accounts = useSelector(accountsSelector) || []
  const [selectedAccDetails, setSelectedAccDetails] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const pageLimit = 10
  const [slicedDetailStatementList, setSlicedDetailStatementList] = useState([])
  const [totalRecords, setTotalRecords] = useState(10)
  const [successResponse, setSuccessResponse] = useState({})
  const [remarksList, setRemarkList] = useState([])

  useEffect(() => {
    getTransactionListForRepay(0)
  }, [])

  const getRemarksList = useCallback(async () => {
    try {
      setLoading(true)
      const response = await DashboardService.getRemarksCategory()
      if (response.status === 200) {
        setLoading(false)
        setRemarkList(response.data.remarks)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const getTransactionListForRepay = useCallback(
    async (page) => {
      try {
        setStage(0)
        let reqParam = {
          module: 'FUNDTRANSFER',
          fromDate: '',
          toDate: '',
          page: page,
          size: pageLimit,
        }
        const response = await BeneficiaryTransferService.lastNTransaction(reqParam)
        if (response.status === 200) {
          setStatementList(response.data['receiptDetails'])
          setTotalRecords(response.data['totalItems'])
          sliceDetailedStatement(1, response.data['receiptDetails'])
          setStage(1)
        }
      } catch (err) {}
    },
    [statementList, totalRecords],
  )

  const paginationChange = useCallback(
    async (page) => {
      setCurrentPage(page)
      await getTransactionListForRepay(page - 1)
    },
    [currentPage],
  )

  const sliceDetailedStatement = useCallback(async (currentPageNo, lst) => {
    // useEffect (  () => {
    // setCurrentPage(currentPageNo)
    let start = (currentPageNo - 1) * pageLimit
    let end = currentPageNo * pageLimit
    if (lst && lst.length > 0) {
      let x = lst.slice(start, end < lst.length ? end : lst.length)
      setSlicedDetailStatementList(x)
    } else {
    }
  }, [])

  const handleSelect = useCallback(
    (selected) => {
      getRemarksList()
      const current = accounts.filter(
        (ele) => ele.accountNo === selected?.reqObj?.fin?.srcAccount,
      )[0]

      setSelectedAccDetails(current)
      setSelectedDetails(selected)
      setFormValues({
        ...formValues,
        transferAmount: selected?.reqObj?.fin?.amount,
        amount: selected?.reqObj?.fin?.amount,
      })
      setStage(2)
    },
    [accounts],
  )

  const onVerify = useCallback(
    async (values) => {
      try {
        if (values.transferAmount === '0.00' || values.transferAmount === '.00') {
          // setMessage({ code: 'Internal', message: 'Amount should be greater than 0 ' })
          // showModal()
          return
        }
        setLoading(true)
        setFormValues(values)
        const reqParams = {
          ...selectedDetails?.reqObj,
        }
        reqParams.fin.amount = values.transferAmount
        reqParams.nfin.otp = ''
        reqParams.nfin.addBeneficiary = false
        reqParams.fin.remarks = values.remarks === 'Custom' ? values.customRemarks : values.remarks
        reqParams.requestId = `FTVERIFY${reqParams?.nfin?.transferType}`
        const response =
          reqParams?.nfin?.transferType === 'OAT'
            ? await QuickPayService.fundTransferVerify(reqParams)
            : reqParams?.nfin?.beneId
            ? await BeneficiaryTransferService.verifyFundTransfer(reqParams)
            : await QuickPayService.fundTransferVerify(reqParams)

        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnabled'])
          setVerifyDetails(response.data)
          setStage(3)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [selectedDetails],
  )

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const reqParams = {
        ...selectedDetails?.reqObj,
      }
      reqParams.fin.amount = formValues.transferAmount
      reqParams.nfin.otp = otp
      reqParams.nfin.addBeneficiary = false
      reqParams.fin.remarks =
        formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks
      reqParams.requestId = `FTCONFIRM${reqParams?.nfin?.transferType}`
      const response =
        reqParams?.nfin?.transferType === 'OAT'
          ? await QuickPayService.fundTransferConfirm(reqParams)
          : reqParams?.nfin?.beneId
          ? await BeneficiaryTransferService.confirmFundTransfer(reqParams)
          : await QuickPayService.fundTransferConfirm(reqParams)
      if (response.status === 200) {
        setSuccessResponse(response.data)
        setMessage(response.data['message'])
        dispatch(setAccRefresh(true))
        setStage(5)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
  }, [selectedDetails, otp, formValues])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderTransactionList()
      case 2:
        return renderForm()
      case 3:
        return renderConfirm()
      case 4:
        return (
          <div className='new-design-form-style'>
            <div className='heading-style1'>
              {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.REPEAT)}
            </div>
            <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
          </div>
        )
      case 5:
        return (
          <div className='new-design-form-style'>
            <div className='heading-style1'>
              {' '}
              {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.REPEAT)}
            </div>
            <NeoSuccess
              onClick1={() =>
                BeneficiaryTransferService.downLoadReport({
                  transRefNum: successResponse.referenceNo,
                  refId: '',
                  module: 'FUNDTRANSFER',
                })
              }
              module='DOWNLOAD_RECEIPT'
              message={message}
              linkPath='/beneficiary-transfers'
            />
          </div>
        )

      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <div className='new-design-form-style'>
        <div className='heading-style1'>
          {' '}
          {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.REPEAT)}
        </div>
        <AccountDisplay currentAccountDetail={selectedAccDetails} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay
          beneDetails={{
            beneName: selectedDetails?.reqObj?.nfin?.beneficiaryName,
            beneAccNo: selectedDetails?.reqObj?.fin?.destAccount,
            image: null,
          }}
        />
        <Formik
          initialValues={{
            transferAmount: selectedDetails?.reqObj?.fin?.amount,
            amount: selectedDetails?.reqObj?.fin?.amount,
            remarks: '',
            customRemarks: '',
          }}
          enableReinitialize
          validationSchema={RepeatTransferSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, setFieldValue, handleChange, values }) => (
            <Form>
              <div className='form-group'>
                <NeoInput
                  tabIndex='1'
                  text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.TRANSFER_AMOUNT)}
                  name='amount'
                  value={values.transferAmount}
                  onChange={(values) => {
                    setFieldValue('transferAmount', values.value)
                  }}
                  mode='amount'
                />
                <InputError text={errors.transferAmount} touched={touched.transferAmount} />
                <InputError
                  text={t(VALIDATION_MESSAGES.AMOUNT_VALID)}
                  touched={values.transferAmount === '0.00' || values.transferAmount === '.00'}
                />
              </div>

              <div className='mt-3 form-group'>
                <NeoInput
                  tabIndex='2'
                  text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.REMARKS)}
                  mode='select'
                  name='remarks'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={remarksList}
                  keyValue={null}
                  value={values.remarks}
                />
                <InputError text={errors.remarks} touched={touched.remarks} />
              </div>

              {values.remarks === 'Custom' && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='3'
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CUSTOM_REMARK)}
                      onChange={handleChange}
                      name='customRemarks'
                      maxLength={config.REMARKS_MAX}
                    />
                    <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                  </div>
                </div>
              )}

              <div className='mt-3'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='4'
                    type='submit'
                    mode={'newDesign'}
                    disabled={isSubmitting}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
                <button
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  tabIndex={'5'}
                  onClick={() => setStage(1)}>
                  {' '}
                  {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirm() {
    return (
      <div className='new-design-form-style'>
        <div className='heading-style1'>
          {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.REPEAT)}
        </div>
        <AccountDisplay currentAccountDetail={selectedAccDetails} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay
          beneDetails={{
            beneName: selectedDetails?.reqObj?.nfin?.beneficiaryName,
            beneAccNo: selectedDetails?.reqObj?.fin?.destAccount,
            image: null,
          }}
        />
        <div className='d-flex flex-column confirmation'>
          <div>
            <h6 className='label'>
              {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.TRANSFER_AMOUNT1)}
            </h6>
            <h6 className='value'>{formValues?.transferAmount}</h6>
          </div>

          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.currency)}</h6>
            <h6 className='value'>{selectedDetails?.reqObj?.fin?.txnCurrency}</h6>
          </div>

          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.CHARGES)}</h6>
            <h6 className='value'>
              <NumberFormat
                value={verifyDetails?.charges || 0}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </h6>
          </div>

          <div>
            <h6 className='label'>
              {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS1)}
            </h6>
            <h6 className='value'>
              {formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks}
            </h6>
          </div>

          <div>
            <TermsAndConditions module='BENEFICIARYTRANSFER' />
          </div>

          <div className='mt-3'>
            {loading ? (
              renderLoading()
            ) : (
              <NeoButton
                mode='newDesign'
                type='button'
                className='btn btn-neo'
                onClick={() => (otpEnabled ? setStage(4) : onConfirm())}
                text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.CONFIRM)}
              />
            )}
          </div>

          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {' '}
            {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
          </div>
        </div>
      </div>
    )
  }

  function renderTransactionList() {
    return (
      <>
        <div className='heading-style1'>
          {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.REPEAT)}
        </div>
        {statementList.map((option, index) => (
          <div key={index} className='rePayment-card'>
            <div>
              <span style={{ display: 'block' }}>{option?.reqObj?.nfin?.beneficiaryName}</span>
              <span>{option?.reqObj?.fin?.destAccount}</span>
            </div>

            <div className='d-flex align-items-center'>
              <div>
                <label>{option?.reqObj?.fin?.txnCurrency}</label>
                <NumberFormat
                  value={option?.reqObj?.fin?.amount}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              </div>
              <div>
                <h6 onClick={() => handleSelect(option)}>
                  {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.PAY)}
                </h6>
              </div>
            </div>
          </div>
        ))}
        <br />
        {statementList.length > 0 ? (
          <div className='d-flex justify-content-center mb-5 mt-2'>
            {loading ? null : (
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={pageLimit}
                totalItemsCount={totalRecords}
                pageRangeDisplayed={5}
                itemClass='page-item'
                linkClass='page-link'
                onChange={paginationChange}

                // onChange={(page) => sliceDetailedStatement(page, statementList)}
              />
            )}
          </div>
        ) : null}
      </>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='BENE_REPEAT'
      showEmptySpace={true}
      keyPath={'BENE_REPEAT'}>
      {renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
